import { Box } from '@mui/material';
import { FC } from 'react';

import { styles } from './styles';

import type { AgreementBoxProps } from './types';

export const AgreementBox: FC<AgreementBoxProps> = ({ isSmallScreen, content }) => (
    <Box css={isSmallScreen ? styles.wrapperDrawer : styles.wrapper}>{content}</Box>
);
